class AttributeSelector {
  constructor(variantAttributeData, initialData) {
    this.variantAttributeData = variantAttributeData;
    this.fabricRequired = initialData.fabric_required;
    this.initialPrice = initialData.price;
    this.attributeNames = initialData.attribute_names;
    this.overallHeight = initialData.overall_height;
    this.activeAttributeCount = initialData.active_attribute_count;
    this.totalAdditionalCosts = 0;
    this.addSelectionClass = this.addSelectionClass.bind(this);
    this.updateAttributeSelectorAndPrice =
      this.updateAttributeSelectorAndPrice.bind(this);
    this.init();
  }

  init() {
    const self = this;
    if (!this.allRequiredAttributesSelected()) {
      this.disablePaymentButtons(true);
    }
    this.updateFabricPrices(this.fabricRequired);
    this.updateFabricRequiredQty(this.fabricRequired);
    this.updateVariantPrice(this.initialPrice);
    let addToCartForm = document.querySelector('form[action$="/cart/add"]');
    addToCartForm.addEventListener("ajaxProduct:added", function (event) {
      self.addAdditonalCosts(event);
    });

    for (const attribute of this.attributeNames) {
      self[`attrDrawer${attribute}`] = new window.theme.Drawers(
        `AttributeDrawer_${attribute}`,
        attribute
      );
      self[`attrDrawer${attribute}`].init();

      const optionAddButtons = document.querySelectorAll(
        `#AttributeDrawer_${attribute} button[name="add-option"]`
      );
      for (let optionAddButton of optionAddButtons) {
        optionAddButton.addEventListener("click", function (evt) {
          self.updateAttributeSelectorAndPrice(evt);
          self[`attrDrawer${attribute}`].close();
        });
        if (optionAddButton.classList.contains("option__selected")) {
          optionAddButton.click();
        }
      }
    }
    this.addListeners();
  }

  addListeners() {
    const self = this;
    document.addEventListener("variant:change", function (evt) {
      window.selectedVariantId = evt.detail.variant.id;
      for (let attributeData of variantAttributeData) {
        if (evt.detail.variant.id == attributeData.id) {
          self.updateFabricPrices(attributeData.fabric_multiplier);
          self.updateFabricRequiredQty(attributeData.fabric_multiplier);
          let currentSelectedFabric = document.querySelector(
            ".option__selected_fabric"
          );
          if (currentSelectedFabric) {
            currentSelectedFabric.click();
          }
        }
      }

      self.updateVariantPrice(evt.detail.variant.price);
      self.disablePaymentButtons(!self.allRequiredAttributesSelected());
    });
  }

  updateAttributeSelectorAndPrice(evt) {
    const self = this;
    let selectedOptionsPrice = 0;
    const buttonData = evt.currentTarget.dataset;
    let attributeSelector = document.getElementById(
      `AttributeDrawer__${buttonData.optionAttribute}_selector`
    );
    const formattedOptionName = buttonData.optionName.replace(" - (", "</br>(")
    attributeSelector.classList.add("selected__option_set");
    attributeSelector.dataset.selectedOptionName = buttonData.optionName;
    attributeSelector.dataset.selectedOptionId = buttonData.optionId;
    attributeSelector.innerHTML = `<img height="75" src="${
      buttonData.optionImage
    }"> <span>${
      formattedOptionName
    } <span class="selected__option_price" data-selected-option-price="${
      buttonData.optionPrice
    }" id="AttributeDrawer__${
      buttonData.optionAttribute
    }_selector_price">${window.theme.Currency.formatMoney(
      buttonData.optionPrice,
      window.theme.settings.moneyFormat
    )}</span><span class="selected__option_update">Update Selection ></span></span>`;
    const selectedOptionsPrices = document.querySelectorAll(
      ".selected__option_price"
    );
    for (let selectedPrice of selectedOptionsPrices) {
      selectedOptionsPrice += Number(selectedPrice.dataset.selectedOptionPrice);
    }

    const selectionTotalPrice = Number(selectedOptionsPrice * 100);
    const productPrice = document.querySelector("[data-product-price]");
    const cleanProductPrice = productPrice.dataset.originalPrice.replaceAll(",","")
    self.totalAdditionalCosts = selectionTotalPrice;
    productPrice.innerText = window.theme.Currency.formatMoney(
      Number(cleanProductPrice * 100) +
        Number(selectionTotalPrice),
      window.theme.settings.moneyFormat
    );

    if (buttonData.optionAttribute !== 'fabric') {
      if (buttonData.optionHeight && this.overallHeight > 0) {
        this.updateOverallHeight(Number(buttonData.optionHeight), attributeSelector.dataset.attributeName);
      } else {
        this.updateOverallHeight(0, false);
      }
    }

    this.addSelectionClass(
      buttonData.optionAttribute,
      evt.currentTarget,
      buttonData.optionId
    );
    if (self.allRequiredAttributesSelected()) {
      self.disablePaymentButtons(false);
    }

    setTimeout(() => {
      self[`attrDrawer${buttonData.optionAttribute}`].close()
    }, 500)
  }

  addSelectionClass(attribute, elem, optionId) {
    const selectedClass = `option__selected_${attribute}`;
    let currentSelected = document.querySelectorAll(
      `.${selectedClass}:not([data-option-id="${optionId}"])`
    );
    if (currentSelected.length) {
      for (let selected of currentSelected) {
        selected.classList.remove("option__selected");
        selected.classList.remove(selectedClass);
      }
    }
    elem.classList.add(selectedClass);
    elem.classList.add("option__selected");
    let additionalButtons = document.querySelectorAll(
      `[data-option-id="${optionId}"]`
    );
    for (let additionalButton of additionalButtons) {
      if (!additionalButton.classList.contains(selectedClass)) {
        additionalButton.classList.add("option__selected");
        additionalButton.classList.add(selectedClass);
      }
    }
    refreshFsLightbox();
  }

  disablePaymentButtons(disabled) {
    let paymentButtonEle = document.querySelector(".add-to-cart");
    let productPriceEle = document.querySelector(".product-block--price");
    if (productPriceEle) {
      productPriceEle.style.opacity = Number(!disabled)
    }
    if (paymentButtonEle) {
      paymentButtonEle.disabled = disabled;
    }
  }

  allRequiredAttributesSelected() {
    const attributeSelections = document.querySelectorAll(
      ".AttributeDrawer__selector.selected__option_set"
    );
    return (
      attributeSelections &&
      attributeSelections.length == this.activeAttributeCount
    );
  }

  addAdditonalCosts(evt) {
    const attributeSelections = document.querySelectorAll(
      ".AttributeDrawer__selector"
    );
    const customisationVariantId = 47630006419649;
    const linkUUID = this.generateUUID();
    if (
      !this.allRequiredAttributesSelected() ||
      evt.detail.product.id == customisationVariantId
    ) {
      console.log("Not enough options selected or adding customisation");
      return;
    }

    let customisationName = evt.detail.product.title;
    let productProperties = evt.detail.product.properties
      ? evt.detail.product.properties
      : {};
    for (let attribute of attributeSelections) {
      productProperties[attribute.dataset.attributeName] = attribute.dataset.selectedOptionName;
      if (attribute.dataset.attributeName == "Fabric") {
        productProperties["_fabric_id"] = attribute.dataset.selectedOptionId
      }
    }
    customisationName = customisationName.trim();
    productProperties["_price_with_customisation"] =
      this.totalAdditionalCosts + evt.detail.product.price;
    productProperties["_customisation_item_uuid"] = linkUUID;
    if (this.fabricRequired > 0) {
      productProperties["Fabric Length"] = this.fabricRequired + "m";
    }

    if (this.overallHeight > 0) {
      productProperties["Overall Height"] = this.overallHeight + "cm";
    }

    let itemProperties = {
      id: evt.detail.product.key,
      properties: productProperties,
    };

    let properties = {
      _customisation_parent_uuid: linkUUID,
      _customisation_original_price: this.totalAdditionalCosts,
      "Components for": customisationName,
    };
    let formData = {
      items: [
        {
          id: customisationVariantId,
          quantity: this.totalAdditionalCosts,
          properties: properties,
        },
      ],
    };

    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(itemProperties),
    })
      .then(() => {
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }).then(() => {
          document.dispatchEvent(new CustomEvent("cart:build"));
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  zoomOption(evt) {
    const zoomButtom = evt.currentTarget;
    let optionItem = zoomButtom.closest(
      ".productAttributeDrawer__option_container"
    );
    optionItem.classList.toggle("option__zoomed");
  }

  updateVariantPrice(price) {
    const self = this;
    const productPrice = document.querySelector("[data-product-price]");
    productPrice.classList.add("price-fade");
    setTimeout(function () {
      productPrice.dataset.originalPrice = window.theme.Currency.formatMoney(
        price,
        "{{ amount }}"
      );
      productPrice.innerHTML = window.theme.Currency.formatMoney(
        price + self.totalAdditionalCosts
      );
      productPrice.classList.remove("price-fade");
    }, 500);
  }

  updateFabricRequiredQty(quantity) {
    this.fabricRequired = quantity
    const fabricQtyElement = document.getElementById(
      "AttributeDrawer__selector_fabric_required"
    );
    if (fabricQtyElement) {
      fabricQtyElement.innerHTML = `(${quantity}m required)`;
    }
  }

  updateFabricPrices(multiplier) {
    const fabricPrices = document.querySelectorAll(
      "#AttributeDrawer_fabric .productAttributeDrawer__options_price"
    );
    if (fabricPrices.length) {
      for (let fabricPrice of fabricPrices) {
        let fabricPriceInnerText = fabricPrice.innerText.trim();
        fabricPrice.innerText = window.theme.Currency.formatMoney(
          (fabricPrice.dataset.originalOptionPrice * multiplier).toFixed(2),
          window.theme.settings.moneyFormat
        );

        let optionItem = fabricPrice.closest("li");
        let optionAddButton = optionItem.querySelector(
          'button[name="add-option"]'
        );
        if (optionAddButton) {
          optionAddButton.dataset.optionPrice = (
            fabricPrice.dataset.originalOptionPrice * multiplier
          ).toFixed(2);
        }
      }
    }
  }

  updateOverallHeight(attributeHeight, attribute) {
    const productHeightElement = document.getElementById(
      "AttributeDrawer__selector_overall_height"
    );
    if (productHeightElement) {
      if (attributeHeight === 0) {
        productHeightElement.innerHTML = "";
        return  
      }
      const productHeight =
        parseFloat(productHeightElement.dataset.productHeight) +
        parseFloat(attributeHeight);
      this.overallHeight = productHeight;
      productHeightElement.innerHTML = `(Overall height with ${attribute} ${productHeight}cm)`;
    }
  }

  generateUUID() {
    if (crypto && typeof crypto.randomUUID === "function") {
      return crypto.randomUUID();
    } else {
      return this.generateTimeBasedUUID();
    }
  }

  generateTimeBasedUUID() {
    const time = new Date().getTime();
    const timeHex = time.toString(16);
    const randomPart = Math.random().toString(16).substring(2, 10);
    const randomPart2 = Math.random().toString(16).substring(2, 10);
    return `${timeHex.substring(0, 8)}-${randomPart.substring(
      0,
      4
    )}-4${randomPart.substring(4, 7)}-a${randomPart2.substring(
      0,
      3
    )}-${randomPart2.substring(3, 12)}`;
  }

  waitForElement(selector, callback, timeout = 5000, timeoutCallback = null) {
    const observer = new MutationObserver((mutations, observer) => {
      if (document.querySelector(selector)) {
        callback();
        observer.disconnect();
        clearTimeout(timer); // Clear the timeout if the element is found
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Check if the element is already in the DOM
    if (document.querySelector(selector)) {
      callback();
      observer.disconnect();
      return; // No need to set up the timeout if element is already found
    }

    // Set up a timeout to disconnect the observer after a certain time
    const timer = setTimeout(() => {
      observer.disconnect();
      if (timeoutCallback) {
        timeoutCallback();
      }
    }, timeout);
  }
}

const loadedEvent = new CustomEvent("attributeSelector::loaded", {
  bubbles: true,
  cancelable: true,
});
window.dispatchEvent(loadedEvent);
